
// @ts-nocheck


export const localeCodes =  [
  "da-DK",
  "en-GB",
  "de-DE",
  "lv-LV",
  "sv-SE",
  "pl-PL"
]

export const localeLoaders = {
  "da-DK": [
    {
      key: "locale_da_45DK_46ts_bcd13186",
      load: () => import("#nuxt-i18n/bcd13186" /* webpackChunkName: "locale_da_45DK_46ts_bcd13186" */),
      cache: false
    }
  ],
  "en-GB": [
    {
      key: "locale_en_45GB_46ts_22e4677c",
      load: () => import("#nuxt-i18n/22e4677c" /* webpackChunkName: "locale_en_45GB_46ts_22e4677c" */),
      cache: false
    }
  ],
  "de-DE": [
    {
      key: "locale_de_45DE_46ts_0fd7326c",
      load: () => import("#nuxt-i18n/0fd7326c" /* webpackChunkName: "locale_de_45DE_46ts_0fd7326c" */),
      cache: false
    }
  ],
  "lv-LV": [
    {
      key: "locale_lv_45LV_46ts_d4d5e8f1",
      load: () => import("#nuxt-i18n/d4d5e8f1" /* webpackChunkName: "locale_lv_45LV_46ts_d4d5e8f1" */),
      cache: false
    }
  ],
  "sv-SE": [
    {
      key: "locale_sv_45SE_46ts_fc01456e",
      load: () => import("#nuxt-i18n/fc01456e" /* webpackChunkName: "locale_sv_45SE_46ts_fc01456e" */),
      cache: false
    }
  ],
  "pl-PL": [
    {
      key: "locale_pl_45PL_46ts_c21fbca9",
      load: () => import("#nuxt-i18n/c21fbca9" /* webpackChunkName: "locale_pl_45PL_46ts_c21fbca9" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/2bccd8bd" /* webpackChunkName: "config_vueI18n_46config_46ts_2bccd8bd" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      name: "Dansk",
      code: "da-DK",
      language: "da-DK",
      dir: "ltr",
      files: [
        {
          path: "/home/vsts/work/1/s/i18n/locales/da-DK.ts",
          cache: undefined
        }
      ]
    },
    {
      name: "English",
      code: "en-GB",
      language: "en-GB",
      dir: "ltr",
      files: [
        {
          path: "/home/vsts/work/1/s/i18n/locales/en-GB.ts",
          cache: undefined
        }
      ]
    },
    {
      name: "Deutsch",
      code: "de-DE",
      language: "de-DE",
      dir: "ltr",
      files: [
        {
          path: "/home/vsts/work/1/s/i18n/locales/de-DE.ts",
          cache: undefined
        }
      ]
    },
    {
      name: "Latviešu",
      code: "lv-LV",
      language: "lv-LV",
      dir: "ltr",
      files: [
        {
          path: "/home/vsts/work/1/s/i18n/locales/lv-LV.ts",
          cache: undefined
        }
      ]
    },
    {
      name: "Svenska",
      code: "sv-SE",
      language: "sv-SE",
      dir: "ltr",
      files: [
        {
          path: "/home/vsts/work/1/s/i18n/locales/sv-SE.ts",
          cache: undefined
        }
      ]
    },
    {
      name: "Polski",
      code: "pl-PL",
      language: "pl-PL",
      dir: "ltr",
      files: [
        {
          path: "/home/vsts/work/1/s/i18n/locales/pl-PL.ts",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "da-DK",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "./locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    name: "Dansk",
    code: "da-DK",
    language: "da-DK",
    dir: "ltr",
    files: [
      {
        path: "/home/vsts/work/1/s/i18n/locales/da-DK.ts",
        cache: undefined
      }
    ]
  },
  {
    name: "English",
    code: "en-GB",
    language: "en-GB",
    dir: "ltr",
    files: [
      {
        path: "/home/vsts/work/1/s/i18n/locales/en-GB.ts",
        cache: undefined
      }
    ]
  },
  {
    name: "Deutsch",
    code: "de-DE",
    language: "de-DE",
    dir: "ltr",
    files: [
      {
        path: "/home/vsts/work/1/s/i18n/locales/de-DE.ts",
        cache: undefined
      }
    ]
  },
  {
    name: "Latviešu",
    code: "lv-LV",
    language: "lv-LV",
    dir: "ltr",
    files: [
      {
        path: "/home/vsts/work/1/s/i18n/locales/lv-LV.ts",
        cache: undefined
      }
    ]
  },
  {
    name: "Svenska",
    code: "sv-SE",
    language: "sv-SE",
    dir: "ltr",
    files: [
      {
        path: "/home/vsts/work/1/s/i18n/locales/sv-SE.ts",
        cache: undefined
      }
    ]
  },
  {
    name: "Polski",
    code: "pl-PL",
    language: "pl-PL",
    dir: "ltr",
    files: [
      {
        path: "/home/vsts/work/1/s/i18n/locales/pl-PL.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/